import QApi from './base/qapi';
import * as qinit from '../qinit';
import { trustedTime } from '../lib/dateTime';

(() => {
  // QApi's toJson method swizzling:
  // this hack is needed since the lib does not expose the response headers
  // but we need those headers to refresh (cached) rules

  const toJsonMethod = QApi.prototype.toJson;
  // Here we're doing a forbidden assignment to the prototype, we need to use
  // any
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  (QApi.prototype as any).toJson = async function toJson<T>(
    response: Response
  ) {
    const data = await toJsonMethod<T>(response);
    const headers = response.headers;
    trustedTime.syncTimeFromHeader(headers.get('Date'));
    return { data, headers };
  };
})();

const api = new QApi(qinit.application.apiBaseUrl);

export const getApi = () => api;
